module.exports = __webpack_public_path__ + "img/AL273HS-2.cff68c9e.jpg";